import logoUrl from '@/assets/kura-logo.svg';

export interface LogoProps {
  /** Tailwind size classes applied to the wordmark image. */
  className?: string;
}

/**
 * Kura brand wordmark. The app is called **Kura** — never tag it "Payments" in the wordmark itself (the product name is a caption, `app.name`).
 */
export function Logo({ className = 'h-7 w-auto' }: LogoProps) {
  return <img src={logoUrl} alt="Kura" className={className} />;
}
